import { PAGE_BLOCK_NAMES, type PageBlockName } from '@/legacy-src/components/pageBlocks/config'

import type { PopulateEntry } from '@/src/domains/strapi/types'

const populateParamOverrides: Partial<Record<PageBlockName, string[]>> = {
  'topics-block': ['tagList', 'common'],
  'promo-block': ['slide', 'common'],
  'features-block': ['features', 'common'],
  'form-block': ['form', 'author', 'common', 'image'],
  'checkmarks-block': ['common', 'list', 'coloredBox', 'image'],
  'insurance-table-block': ['common', 'tableHeader', 'tableRows'],
  'how-it-works-block': ['common', 'howItWorks'],
  'price-list-block': ['common', 'services'],
  'how-it-works-arrows-block': ['common', 'howItWorks'],
  'boxes-block': ['common', 'boxes'],
  'newsletter-block': ['form', 'common', 'benefits'],
  'youtube-video-block': ['common', 'youtubeCoverImage'],
  'services-list-block': ['common', 'categories'],
}

// Helper function to create populate object for Strapi
const createPageBlockPopulate = () => {
  return PAGE_BLOCK_NAMES.reduce(
    (acc, blockName) => {
      const override = populateParamOverrides[blockName]
      acc[`page-block.${blockName}`] = {
        populate: override
          ? override.reduce((acc, field) => {
              return { ...acc, [field]: { populate: '*' } }
            }, {})
          : '*',
      }
      return acc
    },
    {} as Record<`page-block.${PageBlockName}`, NonNullable<PopulateEntry['on']>>,
  )
}

// comprehensive variant which should populate all the blocks correctly
// but is causing performance issues (up to 1.5s for fetch)
export const appContentPopulate: PopulateEntry = {
  on: {
    ...createPageBlockPopulate(),
    'component.list-content': { populate: { listContentItem: { populate: '*' } } },
    'component.button-link': { populate: '*' },
    'page-block.pages-collection-block': {
      populate: {
        pagesCollection: {
          fields: ['documentId'],
        },
      },
    },
  },
}

// simple variant which fails to populate some of the more complex blocks
// (ie. the exceptions from populateParamOverrides)
// export const appContentPopulate = { populate: '*' }

// this variant is failing because only '*' is allowed in polymorphic relations
// (The 'on' pattern above is an exception: in Strapi, the 'on' key allows specifying population rules for each component type within a polymorphic relation, whereas outside of 'on', only '*' is permitted.)
// export const appContentPopulate = { populate: ['tagList', 'common', 'slide', 'features', 'form', 'author'] }
